// removed by extract-text-webpack-plugin
module.exports = {"adBar":"_36TMjv9Gsp6JNZWmwEogJX","hidden":"_1Be6DAkK8IiHD4AnuZzXUZ","content":"_2fORKzscqPMBc1qZ79R3pr","button":"_1zugxErfJrkINgusB2Daey","closer":"_3Dg101HBf5MQJLWCpkXulw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdBar/AdBar.scss
// module id = 1236
// module chunks = 1